import { render, staticRenderFns } from "./activityLive.vue?vue&type=template&id=0835d772&scoped=true&"
import script from "./activityLive.vue?vue&type=script&lang=js&"
export * from "./activityLive.vue?vue&type=script&lang=js&"
import style0 from "./activityLive.vue?vue&type=style&index=0&id=0835d772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835d772",
  null
  
)

export default component.exports